module.exports = __webpack_public_path__ + "static/dg-1-7d524b5264de2d9c5b1a2facab8fd97c.png";